var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79166 10.9998C7.79096 11.1205 7.81408 11.2401 7.8597 11.3517C7.90532 11.4634 7.97253 11.565 8.05749 11.6507L11.7242 15.3173C11.8096 15.4028 11.9111 15.4706 12.0228 15.5169C12.1344 15.5631 12.2541 15.5869 12.375 15.5869C12.4959 15.5869 12.6156 15.5631 12.7272 15.5169C12.8389 15.4706 12.9404 15.4028 13.0258 15.3173C13.1113 15.2319 13.1791 15.1304 13.2253 15.0187C13.2716 14.9071 13.2954 14.7874 13.2954 14.6665C13.2954 14.5456 13.2716 14.4259 13.2253 14.3143C13.1791 14.2026 13.1113 14.1011 13.0258 14.0157L9.99166 10.9998L12.9067 7.97483C13.0004 7.8905 13.0758 7.78774 13.128 7.67296C13.1803 7.55818 13.2083 7.43386 13.2102 7.30777C13.2122 7.18168 13.1882 7.05653 13.1396 6.94016C13.0911 6.82378 13.019 6.71868 12.9279 6.63143C12.8369 6.54417 12.7288 6.47664 12.6105 6.43306C12.4922 6.38948 12.3661 6.37078 12.2402 6.37814C12.1143 6.3855 11.9913 6.41876 11.8788 6.47583C11.7664 6.5329 11.6669 6.61256 11.5867 6.70983L8.04832 10.3765C7.8867 10.5441 7.79494 10.767 7.79166 10.9998Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronLeft);
export default __webpack_public_path__ + "static/media/icon-chevron-left.9163b034dc77f39ce38c74abbaca827d.svg";
export { ForwardRef as ReactComponent };